import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxtostring">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtostring')}
            </Typography>
            <p><strong>{translate('fxtostring')}</strong> 任意の値のデータ型を変換して文字列を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の値</td>
                                <td>123</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToString(123) returns "123"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxleft">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxleft')}
            </Typography>
            <p><strong>{translate('fxleft')}</strong> 指定された文字数を返します <strong>{translate('numberofcharacters')}</strong>, 左から数えます</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数字</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Left("abcdefghij", 4) returns "abcd"</div>
                    <div>2. Left("abcdefghij", 2) returns "ab"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmiddle">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmiddle')}
            </Typography>
            <p><strong>{translate('fxmiddle')}</strong> 指定された文字数を返します <strong>{translate('numberofcharacters')}</strong>, 指定された位置から数えます <strong>{translate('start')}</strong>。
            </p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('start')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数字</td>
                                <td>5</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数字</td>
                                <td>7</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Middle("abcdefghij", 5, 7) returns "fg"</div>
                    <div>2. Middle("abcdefghij", 2, 4) returns "cd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxright">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxright')}
            </Typography>
            <p><strong>{translate('fxright')}</strong> 指定された文字数を返します <strong>{translate('numberofcharacters')}</strong>, 右から数えます</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数値</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Right("abcdefghij", 2) は "ij" を返します</div>
                    <div>2. Right("abcdefghij", 5) は"fghij"を返します </div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxstringlength">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxstringlength')}
            </Typography>
            <p><strong>{translate('fxstringlength')}</strong> 文字列の文字数を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcdefghij"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. StringLength("abcdefghij") returns 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtolower">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtolower')}
            </Typography>
            <p><strong>{translate('fxtolower')}</strong> 指定されたテキスト内のすべての文字を小文字で返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"ABCD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToLower("ABCD", 2) returns "abcd"</div>
                    <div>2. ToLower("ABCDefghij", 5) returns "abcdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtoupper">
                7.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtoupper')}
            </Typography>
            <p><strong>{translate('fxtoupper')}</strong> 指定されたテキスト内のすべての文字を大文字で返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcd"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToUpper("abcd", 2) returns "ABCD"</div>
                    <div>2. ToUpper("abcdefghij", 5) returns "ABCDEFGHIJ"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxpatterncount">
                8.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxpatterncount')}
            </Typography>
            <p><strong>{translate('fxpatterncount')}</strong> テキスト内の検索文字列の出現数を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"Mississippi"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The string to search for.</td>
                                <td>"is"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. PatternCount("Mississippi", "is") returns 2</div>
                    <div>2. PatternCount("Mississippi", "s") returns 4</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsubstitute">
                9.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsubstitute')}
            </Typography>
            <p><strong>{translate('fxsubstitute')}</strong> 指定されたテキスト内のすべての検索文字列を置換文字列で置き換えたテキスト文字列を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')},{translate('replacestring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>検索する文字列と置換する文字列</td>
                                <td>[["a", "A"]]</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Substitute("abcdefghij", [[ "a" , "A" ]]) returns "Abcdefghij"</div>
                    <div>2. Substitute("abcdefghij", [[ "ab" , "12" ]]) returns "12cdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrim">
                10.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrim')}
            </Typography>
            <p><strong>{translate('fxtotrim')}</strong> 先頭と末尾のスペースをすべて削除したテキストを返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>" abcd "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrim(" abcd ") returns "abcd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrimall">
                11.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrimall')}
            </Typography>
            <p><strong>{translate('fxtotrimall')}</strong> すべてのスペースを削除したテキストを返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>" Julian       Scott Dunn "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrimAll(" Julian       Scott Dunn ") returns "JulianScottDunn"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxindexofstring">
                12.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxindexofstring')}
            </Typography>
            <p><strong>{translate('fxindexofstring')}</strong> テキスト内の最初の要素のインデックスを返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>検索する文字列</td>
                                <td>"lo"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", "lo") returns 3</div>
                    <div>2. IndexOfString("hello world", " w") returns 5</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsplit">
                13.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsplit')}
            </Typography>
            <p><strong>{translate('fxsplit')}</strong> 指定された文字列内で区切り文字が発生する各ポイントで分割された文字列の配列を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('splitwith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>分割に使用される文字列</td>
                                <td>" "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", " ") returns ["hello", "world"]</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmatch">
                14.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmatch')}
            </Typography>
            <p><strong>{translate('fxmatch')}</strong> 正規文字列または正規表現と一致する文字列の配列を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('regexp')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>正規文字列または正規表現</td>
                                <td>"[A-Z]"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Match("hello world", "[A-Z]") returns ["h", "e", "l", "l", "o", "w", "o", "r", "l", "d"]</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);